import type { SxProps } from '@mui/material';
import React from 'react';

import { useStartRefinFlow } from '@/hooks/useStartRefinFlow.ts';
import { mergeSx } from '@/lib/utils.ts';
import { Button } from '@/ui/Button.tsx';

import useBrainSession from '../../../../../../services/BrainSession/useBrainSession.ts';

import { useHasEnded } from './useHasEnded.ts';

export type CTAProps = {
  sx?: SxProps;
  onClick?: () => void;
};

export const CTA: React.FC<CTAProps> = ({ sx, onClick }) => {
  const { toggleChat } = useBrainSession();
  const ended = useHasEnded();
  const startRefin = useStartRefinFlow();

  if (ended) {
    return (
      <Button
        color="orange"
        sx={mergeSx({ mx: 'auto' }, sx)}
        onClick={() => {
          onClick?.();
          startRefin();
        }}
      >
        Søk om lavere rente
      </Button>
    );
  }

  return (
    <Button
      color="orange"
      sx={mergeSx({ mx: 'auto' }, sx)}
      onClick={() => {
        onClick?.();
        toggleChat({
          goal: 'advent_2024_campaign',
          step: 'init',
        });
      }}
    >
      Meld deg på
    </Button>
  );
};
